import { translations as translationsUploadFile } from "../../../../components/single-registry/upload/UploadFile/constants";

export const translations = {
  ...translationsUploadFile,
  subtitle: {
    id: "vehicle.single.registry.upload.uploadFileWidget.subtitle",
    defaultMessage:
      "You can also download a blank template or one pre-filled with vehicles already registered in your Edenred solutions.",
  },
};
